module.exports = __webpack_public_path__ + "7a271412315bc991a79eb1913a902700.svg";